import {YStack} from "@chayka/ui";
import {Outlet} from "react-router-dom";
import {BottomTabs} from "./BottomTabsComponent";

interface BottomTabsLayoutProps {
  variant?: "authorized" | "unauthorized";
}

export const BottomTabsLayout: React.FC<BottomTabsLayoutProps> = ({variant}) => {
  return (
    <YStack className="relative justify-start items-center flex-1 w-full">
      <YStack className="w-full gap-6 pb-20">
        <Outlet />
      </YStack>
      <BottomTabs variant={variant} />
    </YStack>
  );
};
